export default __webpack_public_path__ + "static/studyoffice-lounge3-52c51466219430f50c77cab62555a249.jpg";